/** QL-13 — mirrors the error keys from `validateQuizConfig`. */
export const T = {
  en_GB: {
    "quiz.noQuestions": "Add at least one question.",
    "quiz.emptyQuestionLabel": "Every question needs a label.",
    "quiz.tooFewOptions": "Every question needs at least two options.",
    "quiz.emptyOptionLabel": "Every option needs a label.",
    "quiz.questionsToAskRange": "Questions per attempt must be at least 1.",
    "quiz.categoryRange": "Every question's category must be between 1 and 10.",
    "quiz.minScoreRange": "Score to pass cannot be negative.",
    "quiz.maxAttemptsRange": "Max attempts must be at least 1.",
    "quiz.attemptResetDaysRange": "Reset days must be at least 1.",
    "quiz.unpassable":
      "No draw can reach that score. Lower the pass score or raise the option scores.",
  },
  nb_NO: {
    "quiz.noQuestions": "Legg til minst ett spørsmål.",
    "quiz.emptyQuestionLabel": "Alle spørsmål trenger en tekst.",
    "quiz.tooFewOptions": "Alle spørsmål trenger minst to alternativer.",
    "quiz.emptyOptionLabel": "Alle alternativer trenger en tekst.",
    "quiz.questionsToAskRange": "Spørsmål per forsøk må være minst 1.",
    "quiz.categoryRange": "Kategorien til hvert spørsmål må være mellom 1 og 10.",
    "quiz.minScoreRange": "Poeng for å bestå kan ikke være negativt.",
    "quiz.maxAttemptsRange": "Maks antall forsøk må være minst 1.",
    "quiz.attemptResetDaysRange": "Antall dager må være minst 1.",
    "quiz.unpassable": "Ingen trekning kan nå den poengsummen. Senk kravet eller øk poengene.",
  },
} as const;
